import { Plan } from 'models/Plan';

export const TRIAL_PERIOD_IN_DAYS = 0;

export const commitsStats = [
	{
		seniority: 'Estagiário',
		minCommits: 10,
		maxCommits: 50,
	},
	{
		seniority: 'Júnior',
		minCommits: 50,
		maxCommits: 150,
	},
	{
		seniority: 'Pleno',
		minCommits: 100,
		maxCommits: 300,
	},
	{
		seniority: 'Sênior',
		minCommits: 200,
		maxCommits: 500,
	},
];

export const freePlan: Plan = {
	id: 'free',
	name: 'Gratuito',
	description: 'Feito para você explorar e testar os recursos',
	features: {
		feature_aIENoQXomr: {
			id: 'feature_aIENoQXomr',
			label: 'Até 20 commits',
			listIndex: 1,
		},
		feature_mJoXhVazB5: {
			id: 'feature_mJoXhVazB5',
			label: 'Geração automática de commits',
			listIndex: 0,
		},
		feature_qBSHPam2bO: {
			id: 'feature_qBSHPam2bO',
			label: 'Não é necessário cartão de crédito',
			listIndex: 2,
		},
	},
	limitations: {
		commits: {
			maxValue: 20,
			type: 'commits',
			unlimited: false,
		},
	},
	price: {
		monthly: 0,
		yearly: 0,
	},
	priceId: {
		monthly: '',
		yearly: '',
	},

	visibility: 'public',
	status: 'active',
	productId: '',
	updatedAt: '',
	createdAt: '',
};
